<!--
	Code taken from https://bitbucket.org/spinspire/svelte-modal/src/master/src/Modal.svelte 
	This code creates a modal element in svelte
	Accessed on 2020-03-06
-->

<script>
	export let background_dark = true;
	export let whole_screen = true;

	let shown = false;
	export function show() {
		shown = true;
	}
	export function hide() {
		shown = false;
	}

	const modalClick = (e) => {
		// stopPropagation so modalWrapper doesn't fire close
		e.stopPropagation();
	};
</script>

<!-- On escape key press close modal -->
<svelte:window
	on:keydown={e => { if (e.keyCode == 27) hide(); }} 
/>
{#if shown}
	<div 
		class={whole_screen ? "modal-wrapper-full-screen" : 'modal-wrapper'} 
		style={`background-color: ${background_dark ? 'rgba(0, 0, 0, 0.6)' : 'unset'}`}
		on:click={hide} 
	>
		<div class="modal" on:click={modalClick}>
			<div class="close" on:click={hide}>&times;</div>
			<slot />
		</div>
	</div>
{/if}

<style>
	.modal-wrapper {
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
	}
	.modal-wrapper-full-screen {
		position: fixed;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
	}
	.modal {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);

		background: #FFFFFF;
		border: 1px solid #CCCCCC;
		box-sizing: border-box;
		box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
	}
	.close {
		cursor: pointer;
		position: absolute;
		font-size: 24px;
		top: 0.5rem;
		right: 1.5rem;
	}
	.close:hover {
		font-weight: bold;
	}
</style>